/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_AreasInputs */

const vi_api_keys_perm_areas = /** @type {(inputs: Api_Keys_Perm_AreasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng`)
};

/**

* @param {Api_Keys_Perm_AreasInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_areas = /** @type {((inputs?: Api_Keys_Perm_AreasInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_AreasInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_areas(inputs)
});